import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { ChatApi } from '../apis/chat.api';
import { IConversationView } from '../interfaces/conversation-view.interface';
import { EnumContexto } from '../interfaces/topic.interface';
import { AyaService } from './aya.service';
import { ChatHistoryStateService } from './chat-history-state.service';

@Injectable({ providedIn: 'root' })
export class ChatLauncherService {
  constructor(
    private chatApi: ChatApi,
    private historyState: ChatHistoryStateService,
    private ayaService: AyaService
  ) {}

  start(contexto?: EnumContexto): Observable<IConversationView> {
    return this.chatApi.createConversation(contexto).pipe(
      takeUntil(this.historyState.resetObservable),
      tap((conversation) => {
        this.ayaService.markLoaded(conversation.id);
        this.historyState.addPlaceholder(conversation.id);
      })
    );
  }
}
